import React from 'react';
import parse from 'html-react-parser';
import PPMBackground from '@/components/customercenter-ui/icons/ppmBackground';
import PPMConfettiBackground from '@/components/customercenter-ui/icons/ppmConfettiBackground';
import PPMMasonEasyPayCreditLogo from '@/components/customercenter-ui/icons/ppmMasonEasyPayCreditLogo';
import PPMMesseysCreditLogo from '@/components/customercenter-ui/icons/ppmMesseysCreditLogo';
import PPMStoneberryCreditLogo from '@/components/customercenter-ui/icons/ppmStoneberryCreditLogo';
import ToolTips from '@/customercenter-ui/tooltip';
import { brandNames } from './brandname';

type TransformProps = {
  currentPPM?: number;
  newPPM?: number;
  increase?: number;
  tooltipContent?: string;
  divisionCode?: string;
};

export const ppmTransform =
  ({ currentPPM, newPPM, increase, tooltipContent, divisionCode }: TransformProps) =>
  (node: any) => {
    if (node.type !== 'text' || !node.data) return;
    const getCreditIcon = (divisionCode = 'ZB') => {
      const siteId = `${divisionCode}Site`;
      if (siteId === brandNames.stoneberry) {
        return <PPMStoneberryCreditLogo className="inline-flex h-[20px] w-[155px]" />;
      }

      if (siteId === brandNames.masseys) {
        return <PPMMesseysCreditLogo className="inline-flex h-[18px] w-[122px]" />;
      }

      if (siteId === brandNames.masonEasyPay) {
        return <PPMMasonEasyPayCreditLogo className="inline-flex h-[20px] w-[190px]" />;
      }

      return <PPMStoneberryCreditLogo className="inline-flex h-[20px] w-[155px]" />;
    };

    const replacements: Record<string, React.ReactNode> = {
      '{{NEW_PPM}}': newPPM != null ? `$${newPPM.toFixed(2)}` : '',

      '{{CURRENT_PPM}}': currentPPM != null ? `$${currentPPM.toFixed(2)}` : '',

      '{{INCREASE}}': increase != null ? `$${increase.toFixed(2)}` : '',

      '{{CREDIT_LOGO}}': getCreditIcon(divisionCode),

      '{{PPM_BACKGROUND}}': <PPMBackground className="h-full w-full" />,

      '{{PPM_CONFETTI_BACKGROUND}}': <PPMConfettiBackground className="h-full w-full" />,

      '{{PPM_TOOLTIP}}': tooltipContent ? (
        <ToolTips
          className="inline-block h-5 w-5 align-middle [&_svg]:h-5 [&_svg]:w-5"
          Content={{
            ContentToolTip: <div className="max-w-[280px] text-left">{parse(tooltipContent)}</div>,
          }}
        />
      ) : (
        ''
      ),
    };

    const regex =
      /(\{\{NEW_PPM\}\}|\{\{CURRENT_PPM\}\}|\{\{INCREASE\}\}|\{\{CREDIT_LOGO\}\}|\{\{PPM_TOOLTIP\}\}|\{\{PPM_BACKGROUND\}\}|\{\{PPM_CONFETTI_BACKGROUND\}\})/g;

    if (!regex.test(node.data)) return;

    const parts = node.data.split(regex);

    return (
      <>
        {parts.map((part: string, index: number) => (
          <React.Fragment key={index}>{part in replacements ? replacements[part] : part}</React.Fragment>
        ))}
      </>
    );
  };
